

const AttachmentView = require('./Attachment.js');
const template = require('employer/templates/governmentForms/EaForms.ejs');
const loader = require('helpers/loader');

module.exports = Backbone.View.extend({
    itemViews: null,

    events: {
        'click .js-eaforms-toggle':          'toggleAll',
        'click .js-generate':                'generateForm',
        'click .js-generate-all':            'generateFormAll'
    },

    initialize: function(options) {
        this.itemViews = [];
        this.collapsed = true;

        this.options = _.defaults(options || {}, {
            attachments: null,
            year: 2025
        });

        this.collection.forEach(employee => {
            this.options.attachments[employee.id].on('reset', () => {
                this.renderItems(employee, 'reset');
            });
        });
    },

    render: function() {
        this.$el.html(template({
            model:      this.model,
            collection: this.collection,
            year: this.options.year
        }));

        this.$('.footable').footable({
            sort: false,
            addRowToggle: true,
            paging: {
                enabled: true
            }
        });

        _.each(this.itemViews, function(view) {
            view.remove();
        });

        this.itemViews = [];

        if (this.collection.length > 0) {
            this.collection.forEach(this.renderItems.bind(this));
        }

        return this;
    },

    renderItems: function(employee, reset) {
        var attachments = this.options.attachments[employee.id];
        const $employee = this.$('.js-employee-' + employee.id);

        if (reset) {
            $employee.html('');
        }

        attachments.forEach(attachment => {
            this.renderItem(attachment, employee);
        });
        if (reset) {
            $employee.fadeIn(200);
        }
    },

    renderItem: function(model, employee) {
        var employeeView = new AttachmentView({model: model});

        this.itemViews.push(employeeView);

        this.$('.js-employee-' + employee.id).append(employeeView.$el);

        return this;
    },

    toggleAll: function(ev) {
        ev.preventDefault();

        this.$('.footable').trigger(
            this.collapsed ? 'footable_expand_all' : 'footable_collapse_all'
        );

        this.collapsed = !this.collapsed;
    },

    generateForm: function(ev) {
        const $button     = this.$(ev.currentTarget);
        const employee    = this.collection.get($button.data('employee'));
        const year        = $button.data('year');
        const attachments = this.options.attachments[employee.id];
        const stopLoader  = loader.startFullScreen($button);

        const $employee = this.$('.js-employee-' + employee.id);
        $employee.fadeOut(200);

        Promise.all([
            employee.generateFormEA(year),
            employee.generateFormExcel(year)
        ])
            .then(() => employee.fetchAttachments(['EA']))
            .then((employeeAttachments) => {
                attachments.reset(employeeAttachments.models);

                var $row    = $button.closest('tr');
                var $detail = $row.next('.footable-row-detail');

                if (!$detail.is(':visible')) {
                    $row.trigger('footable_toggle_row');
                }
            }).finally(stopLoader);
    },

    remove: function() {
        this.undelegateEvents();
        this.itemViews.forEach(view => view.remove());
    }
});



// WEBPACK FOOTER //
// ./app/employer/views/governmentForms/EaForms.js